import { BaseModel } from "@/store/feathers/feathers.client.js";

export default class Invoices extends BaseModel {
  constructor(data, options) {
    super(data, options);
  }

  static modelName = "InvoiceTemplates";

  // eslint-disable-next-line no-unused-vars
  static instanceDefaults(data, { models, store }) {
    return {
      name: null,   // internal use for lists and dropdowns
      description: null,  // summary used for customer emails and forms
      status: 'DRAFT',

      type: 'ONETIME',  // ONETIME, RECURRING
      payment_method: "ONLINE", //ONLINE or AUTOPAY 

      details: {
        title: 'INVOICE',
        invoice_name: null,
        invoice_summary: null,
        id_invoice: null,
        retain_id_invoice: false,
        id_order: null,
        retain_id_order: false,
        id_po: null,
      },

      payment_terms: {
        days: 0,
        enable_ach: true,
        enable_card: true,
        late_days: 5,
        overdue_days: 15,
      },

      recurring: {
        is_fixed: false,
        is_prorated: false,
        interval: null,
        periods: 1,
        dom: 1,  // only applies if DOM interval
        cycles: 1,
        retries: 3,
        enable_autopay: false,
        start_date: new Date(),
        billing_date: null,
        cycle_end_date: null,
        recurring_end_date: null,
        start_date_range: [],
        token: {
          id: null,
          token: null,
          last_4: null,
          nickname: null,
          bank_name: null,
          type: null,
          kind: null,
          brand: null,
          require_authorization: true,
          authorized_at: null,
          authorized_ip: null,
        },
      },
      cart: {
        total_amount: 0,
        total_subtotal: 0,
        total_taxes: 0,
        total_fees: 0,
        total_discounts: 0,

        shipping: 0,
        balance: 0,
        minimum: 0,
        items_sold: 0,

        tax_rate: 0,
        fee_rate: 0,
        discount_rate: 0,

        taxable_amount: 0,
        feeable_amount: 0,
        discountable_amount: 0,

        memo: null,
        items: [],
        taxes: [],
        discounts: [],
        fees: [],
      },
      customer: {
        id: null,
        name: null,
        id_account: null,
        id_customer: null,
        customer_id: null,
        email: null,
        phone: null,
        fax: null,
        website: null,
        default_address: {
          id: null,
          name: null,
          contact: null,
          line_1: null,
          line_2: null,
          phone: null
        },
        billing_address: {
          enabled: false,
          id: null,
          name: null,
          contact: null,
          line_1: null,
          line_2: null,
          phone: null
        },
        shipping_address: {
          enabled: false,
          id: null,
          name: null,
          contact: null,
          line_1: null,
          line_2: null,
          phone: null
        }
      },
      brand: {
        name: null,
        line_1: null,
        line_2: null,
        website: null,
        phone: null,
        email: null,
        logo: {
          image_url: null,
          image_url_dark: null,
          link_url: null,
          width: 200,
          padding_top: 10,
          padding_bottom: 10,
          padding_left: 0
        }
      },
      notifications: {
        // ONLINE
        invoice_notification: {
          enabled: true,
          template_id: 'invoice_notification',
          sent: [],
        },
        invoice_late_notification: {
          enabled: true,
          template_id: 'invoice_late_notification',
          sent: [],
        },
        invoice_overdue_notification: {
          enabled: true,
          template_id: 'invoice_overdue_notification',
          sent: [],
        },
        invoice_delinquent_notification: {
          enabled: true,
          template_id: 'invoice_delinquent_notification',
          sent: [],
        },
        invoice_payment_reminder: {
          enabled: true,
          template_id: 'invoice_payment_reminder',
          sent: [],
        },
        invoice_payment_receipt: {
          enabled: true,
          template_id: 'invoice_payment_receipt',
          sent: [],
        },
        invoice_adjustment: {
          enabled: true,
          template_id: 'invoice_adjustment',
          sent: [],
        },
        invoice_link: {
          enabled: true,
          template_id: 'invoice_link',
          sent: [],
        },
        invoice_payment_request: {
          enabled: true,
          template_id: 'invoice_payment_request',
          sent: [],
        },
        invoice_statement: {
          enabled: true,
          template_id: 'invoice_statement',
          sent: [],
        },

        // AUTOPAY 
        recurring_invoice_notification: {
          enabled: true,
          template_id: 'recurring_invoice_notification',
          sent: [],
        },
        recurring_invoice_receipt: {
          enabled: true,
          template_id: 'recurring_invoice_receipt',
          sent: [],
        },
        recurring_invoice_declined: {
          enabled: true,
          template_id: 'recurring_invoice_declined',
          sent: [],
        },
        recurring_invoice_delinquent: {
          enabled: true,
          template_id: 'recurring_invoice_delinquent',
          sent: [],
        },
        recurring_invoice_overdue: {
          enabled: true,
          template_id: 'recurring_invoice_overdue',
          sent: [],
        },
        recurring_invoice_payment_reminder: {
          enabled: true,
          template_id: 'recurring_invoice_payment_reminder',
          sent: [],
        },
        recurring_invoice_payment_receipt: {
          enabled: true,
          template_id: 'recurring_invoice_payment_receipt',
          sent: [],
        },
      },
      text_blocks: [],
      tags: [],
      contact_id: null,
      company_id: null,
      customer_id: null,
      mid_id: null,
      app_id: store.state.ids.app_id,
      tenant_id: store.state.ids.tenant_id,
      developer_id: store.state.ids.developer_id,
      reseller_id: store.state.ids.reseller_id,
      merchant_id: store.state.ids.merchant_id,
      created_by_id: store.state.ids.user_id,
      updated_by_id: store.state.ids.user_id,
    };
  }

  // eslint-disable-next-line no-unused-vars
  static setupInstance(data, { models, store }) {

    // if (data.schedules) {
    //   data.schedules.map(async (schedule) => {
    //     schedule = new models.api.Schedules(schedule);
    //   });
    // }

    // if (data.transactions) {
    //   data.transactions.map(async (transaction) => {
    //     transaction = new models.api.Transactions(transaction);
    //   });
    // }

    // if (data.contact) {
    //   data.contact = new models.api.Contacts(data.contact);
    // }

    // if (data.company) {
    //   data.company = new models.api.Companies(data.company);
    // }

    // if (data.settings) {
    //   data.settings = new models.api.Settings(data.settings);
    // }

    // if (data.mid) {
    //   data.mid = new models.api.Mids(data.mid);
    // }

    // if (data.cart) {
    //   data.cart = new models.api.Carts(data.cart);
    // }

    // if (data.recurring) {
    //   data.recurring = new models.api.RecurringTemplates(data.recurring);
    // }

    return data;
  }
}
